import React from 'react'
import { t, Trans } from '@lingui/macro'
import {DProductInfoActions} from './actions'
import {FiltersDashboard} from '../DashboardContentTable/FiltersDashboard'
import { DPosFilters} from './filters'
import {InputSearch} from 'components/UI/InputSearch/InputSearch'
import {DataTableDashboard} from '../DashboardContentTable/DataTableDashboard'
import {TableBody, TableHeader} from './tableData'
import {PopupPanelDashboard} from '../DashboardContentTable/PopupPanelDashboard'
import {PopupDetails} from './popupContents/popupDetails'
import {PopupEdit} from './popupContents/popupEdit'
import {PopupAdd} from './popupContents/popupAdd'
import {ConfirmDialogDashboard} from '../DashboardContentTable/ConfirmDialogDashboard'
import {DashboardContentPage} from '../DashboardContentTable'
import {typeDataPosConfigurationRowActions} from './index'
import {IdPosConfigurationStateDataItem} from 'model/dashboardPosConfiguration/dPosConfigurationReducer'


// Type
export type typeViewDataPosConfiguration = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>

    onClickAdd: () => void

    openFilterBar: boolean
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>

    openPopupDetails: boolean
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>

    openPopupAdd: boolean
    setOpenPopupAdd: React.Dispatch<React.SetStateAction<boolean>>

    openPopupEdit: boolean
    setOpenPopupEdit: React.Dispatch<React.SetStateAction<boolean>>

    openDeleteDialog: boolean
    setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>
    onDeleteConfirmHandler: () => void
    onDeleteCancelHandler: () => void

    searchValue: string
    onChangeSearchValue: (e: (React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>)) => void
    onEnterSearch: () => void
    onClearSearch: () => void

    rowsActions: typeDataPosConfigurationRowActions

    currentItem:  IdPosConfigurationStateDataItem | undefined
    isActiveFilters: boolean
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const ViewDataPosConfiguration: React.FC<typeViewDataPosConfiguration> = ({
    variant,
    setSidebarOpen,

    onClickAdd,

    openFilterBar, setOpenFilterBar,

    openPopupDetails, setOpenPopupDetails,

    openPopupAdd, setOpenPopupAdd,

    openPopupEdit, setOpenPopupEdit,

    openDeleteDialog, setOpenDeleteDialog, onDeleteConfirmHandler, onDeleteCancelHandler,

    searchValue, onChangeSearchValue,
    onClearSearch, onEnterSearch,

    rowsActions,

    currentItem,
isActiveFilters, setIsActiveFilters
    }) => {

    return(
        <DashboardContentPage
            headerTitle={<Trans>POS configurations</Trans>}
            setSidebarOpen={setSidebarOpen}
            actions={<DProductInfoActions
                onClickAdd={onClickAdd}
            />}
        >

            {/* Filter bar */}
            <FiltersDashboard
                variant={variant}
                filters={{
                    filtersForm: <DPosFilters setOpenFilterBar={setOpenFilterBar} setIsActiveFilters={ setIsActiveFilters }/>,
                    openFilterBar: openFilterBar,
                    setOpenFilterBar: setOpenFilterBar,
                }}
                searchBar={<InputSearch
                    id="productSearch"
                    name="productSearch"
                    placeholder={t`search by configuration's name`}
                    value={searchValue}
                    onChange={onChangeSearchValue}
                    onClear={onClearSearch}
                    onKeyEnterDown={onEnterSearch}
                />}
                isActiveFilters={ isActiveFilters }
            />

            {/* Table data */}
            <DataTableDashboard
                tableHeader={<TableHeader/>}
                tableBody={<TableBody variant={variant} setOpenPopupDetails={setOpenPopupDetails} rowsActions={rowsActions}/>}
            />

            {/* Popup Details item dialog */}
            <PopupPanelDashboard
                variant={variant}
                title={<Trans>POS configuration details</Trans>}
                openPopup={openPopupDetails}
                setOpenPopup={setOpenPopupDetails}
            >
                <PopupDetails setOpenPopup={setOpenPopupDetails} openPopupEdit={setOpenPopupEdit} openDeleteDialog={setOpenDeleteDialog}/>
            </PopupPanelDashboard>

            {/* Popup Add item dialog */}
            <PopupPanelDashboard
                variant={variant}
                title={<Trans>Add POS configuration</Trans>}
                openPopup={openPopupAdd}
                setOpenPopup={setOpenPopupAdd}
            >
                <PopupAdd setOpenPopup={setOpenPopupAdd}/>
            </PopupPanelDashboard>

            {/* Popup Edit item dialog */}
            <PopupPanelDashboard
                variant={variant}
                title={<Trans>Edit POS configuration</Trans>}
                openPopup={openPopupEdit}
                setOpenPopup={setOpenPopupEdit}
            >
                <PopupEdit setOpenPopup={setOpenPopupEdit}/>
            </PopupPanelDashboard>


            {/* Item Delete dialog */}
            <ConfirmDialogDashboard
                variant={variant}
                type="error"
                title={<Trans>Delete POS configuration</Trans>}
                message={<Trans>Do you really want delete POS configuration <b>{currentItem?.name}</b>?</Trans>}
                primaryButton={{title: <Trans>Delete</Trans>, action:onDeleteConfirmHandler}}
                secondaryButton={{title: <Trans>Cancel</Trans>, action: onDeleteCancelHandler}}
                openDialog={openDeleteDialog}
                setOpenDialog={setOpenDeleteDialog}
            />

        </DashboardContentPage>
    )
}
